import React from "react";
// import placeholder from "../../../assets/images/pages/image-placeholder.png";
import { useNavigate } from "react-router-dom";
// import avatar from "../../../assets/images/svgs/dummy.svg";
// import { confirm_image } from "../../../service/validate/image_confirm";
import { IService } from "../../../store/@types/service";

type IServiceCard = {
  item: IService;
};

const ServiceCard: React.FC<IServiceCard> = ({ item }) => {
  const navigate = useNavigate();
  const placeholder = require("../../../assets/images/pages/image-placeholder.png");
  return (
    <div
      onClick={() => navigate("/dashboard/services/" + item?.id)}
      className="bg-white rounded-xl overflow-hidden shadow-md border border-primary-50/20 transform transition-transform duration-300 hover:shadow-lg hover:-translate-y-1 cursor-pointer"
    >
      <div>
        <img
          loading="lazy"
          src={item.image?.trim() ? item.image : placeholder}
          alt={item.name}
          className="w-full h-48 object-cover"
          onError={(e) => (e.currentTarget.src = placeholder)}
        />
      </div>
      <div className="p-6">
        <h2 className="text-sm lg:text-lg font-medium text-gray-900 mb-2 line-clamp-2 hover:text-blue-600 transition-colors duration-200">
          {item?.name}
        </h2>
      </div>
    </div>
  );
};

export default ServiceCard;
